/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type ExportAuditLogsRequest = {
  /**
   * Export logs created on or after this datetime. Format: ISO_8601
   */
  start_date: string;
  /**
   * Export logs created on or before this datetime. Defaults to now.
   */
  end_date?: string;
  /**
   * User responsible for the change. Omit to include every user.
   */
  user?: number;
  product: ExportAuditLogsRequest.product;
};
export namespace ExportAuditLogsRequest {
  export enum product {
    PORTFOLIO_VALUATIONS = 'portfolio-valuations',
    WORKBOARD = 'workboard',
    ALL = 'all',
  }
}
